module.exports = __webpack_public_path__ + "img/BIT_white18.353decb3.jpg";